import React, { useState, useEffect } from "react";
import dayjs from 'dayjs';

// @material-ui/core components
import Box from "@mui/material/Box";
import TextField from '@mui/material/TextField';
import Modal from "@mui/material/Modal";
import Typography from '@mui/material/Typography';
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from '@mui/material/MenuItem';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

// costumize component
import Button from "components/CustomButtons/Button.js";

// utils 
import { styleBox } from '../../../utils/views/style'

// apis
import { saveCrewApi, updateCrewApi, deleteCrewApi, bulkDeleteCrewApi } from "apis/crew";
import { bulkDeletePromoApi, deletePromoApi, savePromoApi, updatePromoApi } from '../../../apis/promo';
import { Checkbox, FormControlLabel, FormGroup } from '@material-ui/core';

const stylesField = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(stylesField);

// eslint-disable-next-line react/prop-types
const BasicModal = ({ open, modal, modalData, setOpen, setReloadData }) => {
  // variable
  const [label, setLabel] = useState('')
  const [quota, setQuota] = useState(0)
  const [amount, setAmount] = useState(0)
  const [startTime, setStartTime] = useState('')
  const [endTime, setEndTime] = useState('')
  const [isActive, setIsActive] = useState(false)
  const [selectPromoType, setSelectPromoType] = useState('discount')
  const [promoTypeOptions, setPromoTypeOptions] = useState([
    'discount', 'percentage'
  ])
  const [errorMessage, setErrorMessage] = useState('')
  const [errorForeignMessage, setErrorForeignMessage] = useState([])
  const [btnDelete, setBtnDelete] = useState(false)
  const [startTimeDayJs, setStartTimeDayJs] = useState(dayjs());
  const [endTimeDayJs, setEndTimeDayJs] = useState(dayjs());

  // methods
  const handleClose = () => {
    setOpen(false)
    if (modal == 'bulkDelete') setReloadData()
  };

  const handleSavePromo = async (event) => {
    try {
      event.preventDefault()
      setErrorMessage('')
      let response = await savePromoApi({ label, quota, type: selectPromoType, amount, startTime, endTime, isActive })
      setReloadData()
    } catch (error) {
      if (error.response.data.errors.message) {
        setErrorMessage(error.response.data.errors.message)
      } else {
        setErrorMessage(error.response.data.errors[0].message)
      }
    }
  }

  const handleUpdatePromo = async (event) => {
    try {
      event.preventDefault()
      setErrorMessage('')
      let response = await updatePromoApi(modalData.id,{ label, quota, type: selectPromoType, amount, startTime, endTime, isActive })
      setReloadData()
    } catch (error) {
      if (error.response.data.errors.message) {
        setErrorMessage(error.response.data.errors.message)
      } else {
        setErrorMessage(error.response.data.errors[0].message)
      }
    }
  }

  const handleDeletePromo = async () => {
    try {
      setErrorMessage('')
      let response = await deletePromoApi(modalData.id)
      setReloadData()
    } catch (error) {
      if (error.response.data.errors.message) {
        setErrorMessage(error.response.data.errors.message)
      } else {
        setErrorMessage(error.response.data.errors[0].message)
      }
      setBtnDelete(true)
    }
  }


  const bulkDelete = async () => {
    try {
      let idsBulk = []
      modalData.forEach((item) => {
        idsBulk.push(item.id)
      })
      let response = await bulkDeletePromoApi({ ids: idsBulk })
      setReloadData()
    } catch (error) {
      setBtnDelete(true)
      if (error.response.data.errors.message) {
        setErrorMessage(error.response.data.errors.message)
      } else {
        setErrorMessage(error.response.data.errors[0].message)
      }
      if (error.response.data.data.agents) setErrorForeignMessage(error.response.data.data.agents)
    }
  }
  const classes = useStyles();

  useEffect(() => {
    if (modal != 'add' && modal != 'bulkDelete' ){
      setLabel(modalData.label)
      setQuota(modalData.quota)
      setAmount(modalData.amount)
      setIsActive(modalData.isActive)
      setSelectPromoType(modalData.type)
      setStartTimeDayJs(dayjs(modalData.startTime))
      setEndTimeDayJs(dayjs(modalData.endTime))
    }
    setStartTime(dayjs(modalData.startTime).format('YYYY-MM-DD HH:mm:ss'))
    setEndTime(dayjs(modalData.endTime).format('YYYY-MM-DD HH:mm:ss'))
  }, []);

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {
          modal != 'delete' && modal != 'bulkDelete' ?
            <Box sx={{ ...styleBox, width: 400 }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                {modal == 'add' ? 'Tambah Promo' : 'Update Promo'}
              </Typography>
              <Box fullWidth>
                <form onSubmit={modal == 'add' ? handleSavePromo : handleUpdatePromo}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    value={label}
                    onChange={e => setLabel(e.target.value)}
                    label="Nama Promo"
                    autoFocus
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    required
                    fullWidth
                    value={quota}
                    onChange={e => setQuota(e.target.value)}
                    label="Kuota"
                    autoFocus
                  />
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Jenis Promo"
                    helperText="Pilih jenis promo"
                    margin="normal"
                    required
                    fullWidth
                    autoFocus
                    value={selectPromoType}
                    onChange={e => setSelectPromoType(e.target.value)}
                  >
                    {promoTypeOptions.map((option, index) => (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    margin="normal"
                    type="number"
                    required
                    fullWidth
                    value={amount}
                    onChange={e => setAmount(e.target.value)}
                    helperText={`Nominal dalam ${selectPromoType == 'discount' ? 'rupiah': 'persen'} `}
                    label="Nominal"
                    autoFocus
                  />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DateTimeField', 'DateTimeField']}>
                      <DateTimePicker
                        label="Waktu Mulai"
                        value={startTimeDayJs}
                        onChange={(newValue) => { setStartTimeDayJs(newValue); setStartTime(newValue.format('YYYY-MM-DD HH:mm:ss')) }}
                      />
                      <DateTimePicker
                        label="Waktu Berakhir"
                        value={endTimeDayJs}
                        onChange={(newValue) => { setEndTimeDayJs(newValue); setEndTime(newValue.format('YYYY-MM-DD HH:mm:ss')) }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <FormGroup>
                    <FormControlLabel control={
                      <Checkbox 
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                      />
                    } label="Promo Aktif" />
                  </FormGroup>
                  <center>
                    <p>{errorMessage}</p>
                  </center>
                  <Box display="flex" justifyContent="end">
                    <Button
                      color="outline"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      type="submit"
                    >
                      {modal == 'add' ? 'Tambah' : 'Update'}
                    </Button>
                  </Box>
                </form>
              </Box>
            </Box>
            : modal == 'bulkDelete' ?
              <Box sx={{ ...styleBox, width: 400 }}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Apakah Anda ingin menghapus promo
                  {
                    modalData.map((item) => (
                      <span> {item.label}, </span>
                    ))
                  }
                  ?
                </Typography>
                <center>
                  <p>{errorMessage}</p>
                </center>
                <Box display="flex" justifyContent="end">
                  <Button
                    color="outline"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  {
                    !btnDelete ?
                      <Button
                        color="primary"
                        onClick={bulkDelete}
                      >
                        Delete
                      </Button>
                      : ''
                  }
                </Box>
              </Box>
              :
              <Box sx={{ ...styleBox, width: 400 }}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Apakah Anda ingin menghapus Promo <span>{label}</span> ?
                </Typography>
                <center>
                  <p>{errorMessage}</p>
                </center>
                <Box display="flex" justifyContent="end">
                  <Button
                    color="outline"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  {
                    !btnDelete ?
                      <Button
                        color="primary"
                        onClick={handleDeletePromo}
                      >
                        Delete
                      </Button>
                      : ''
                  }
                </Box>
              </Box>
        }

      </Modal>
    </div>
  );
};

export default BasicModal;
